// apiService.js
import { getAuth } from 'firebase/auth';

// Fonction pour récupérer le token d'authentification
export const getAuthToken = async () => {
  const auth = getAuth();
  if (!auth.currentUser) {
    throw new Error('Utilisateur non authentifié');
  }
  
  try {
    // Récupérer un token frais
    return await auth.currentUser.getIdToken(true);
  } catch (error) {
    console.error('Erreur lors de la récupération du token:', error);
    throw new Error('Impossible de récupérer le token d\'authentification');
  }
};

// Fonction pour les requêtes authentifiées
export const makeAuthenticatedRequest = async (url, options = {}) => {
  try {
    const token = await getAuthToken();
    
    const response = await fetch(url, {
      ...options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
      },
      credentials: 'include' // Pour inclure les cookies si nécessaire
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Erreur HTTP: ${response.status}`);
    }

    return response;
  } catch (error) {
    console.error('Erreur lors de la requête authentifiée:', error);
    throw error;
  }
};